import InlineSvg from "./InlineSvg"
import * as React from 'react';

const InfoCard = ({children, backgroundColour, icon}) => {
    return (
        <div className={`info-card info-card--${backgroundColour}`}>
            <InlineSvg name={icon} color={backgroundColour} className='info-card__svg'/>
            {children}
        </div>
    )
}

export default InfoCard